declare namespace $ {

	type $mol_textarea__value_shm_hitalama_map_widget_float_ai_request_html_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_ai_request_html['text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_ai_request_html_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_map_widget_float_ai_request_html_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_ai_request_html_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_ai_request_html['App'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	export class $shm_hitalama_map_widget_float_ai_request_html extends $shm_hitalama_map_widget_float_ai_request_form {
		App( ): $mol_textarea
		App_label( ): $mol_labeler
		sub( ): readonly(any)[]
		next_request_type( ): string
	}
	
}

//# sourceMappingURL=html.view.tree.d.ts.map